import { useFeatureFlagEnabled, useFeatureFlagPayload as usePostHogFeatureFlagPayload } from '@posthog/react';

import type { FeatureFlag, FeatureFlagPayloadMap } from './use-feature-flag.type';

export const useFeatureFlag = (key: FeatureFlag): boolean => useFeatureFlagEnabled(key) ?? false;

/**
 * The flag's three real states: `undefined` until PostHog has loaded flags, then the boolean.
 *
 * `useFeatureFlag` above collapses `undefined` into `false`, which is the right default for
 * DECIDING WHETHER TO SHOW something but wrong for anything that PERSISTS the answer: a write
 * during the load would be indistinguishable from a real `false`. `DevModeProvider` is the only
 * caller (B2B-2345) — gate features on `useFeatureFlag`.
 */
export const useFeatureFlagState = (key: FeatureFlag): boolean | undefined => useFeatureFlagEnabled(key);

export const useFeatureFlagPayload = <K extends FeatureFlag>(key: K): FeatureFlagPayloadMap[K] | undefined =>
  usePostHogFeatureFlagPayload(key) as FeatureFlagPayloadMap[K] | undefined;
